// extracted by mini-css-extract-plugin
export default {"content":"mixes-tab_content__u7mTH","profitBadge":"mixes-tab_profitBadge__WiUf2","label":"mixes-tab_label__rlJ5P","profit":"mixes-tab_profit__ogYds","specs":"mixes-tab_specs__jM7c0"};